import {
    getPopularWPPlugins,
    getPopularWPThemes,
} from '@/services/wp-hosting.service';

const fetchStatuses = {
    NOT_LOADED_YET: 0,
    LOADING: 1,
    LOADED: 2,
};
export const WPHostingModule = {
    state: () => ({
        themes: [],
        fetchThemeStatus: fetchStatuses.NOT_LOADED_YET,
        plugins: [],
        fetchPluginsStatus: fetchStatuses.NOT_LOADED_YET,
        fetchStatuses,
    }),
    mutations: {
        setThemes(state, data) {
            state.themes = data;
        },
        setFetchThemes(state, status) {
            state.fetchThemeStatus = status;
        },
        setPlugins(state, data) {
            state.plugins = data;
        },
        setFetchPlugins(state, status) {
            state.fetchPluginsStatus = status;
        },
    },
    actions: {
        async fetchPopularThemes({ commit, state }, locale) {
            if (fetchStatuses.NOT_LOADED_YET === state.fetchThemeStatus) {
                try {
                    commit('setFetchThemes', fetchStatuses.LOADING);
                    const { data: themes } = await getPopularWPThemes({
                        locale,
                        fields: {
                            description: 0,
                            sections: 0,
                            rating: 0,
                            ratings: 0,
                            downloaded: 0,
                            downloadLink: 0,
                            lastUpdated: 0,
                            homepage: 0,
                            tags: 0,
                            template: 0,
                            parent: 0,
                            versions: 0,
                            screenshotUrl: 1,
                            activeInstalls: 0,
                        },
                    });
                    commit('setThemes', themes);
                    commit('setFetchThemes', fetchStatuses.LOADED);
                } catch {
                    commit('setThemes', []);
                    commit('setFetchThemes', fetchStatuses.NOT_LOADED_YET);
                }
            }
        },
        async fetchPopularPlugins({ commit, state }, locale) {
            if (fetchStatuses.NOT_LOADED_YET === state.fetchPluginsStatus) {
                try {
                    commit('setFetchPlugins', fetchStatuses.LOADING);
                    const { data: plugins } = await getPopularWPPlugins({
                        locale,
                        fields: {
                            description: 0,
                            sections: 0,
                            rating: 0,
                            ratings: 0,
                            downloaded: 0,
                            downloadLink: 0,
                            lastUpdated: 0,
                            homepage: 0,
                            tags: 0,
                            tested: 0,
                            requires: 0,
                            shortDescription: 1,
                            icons: 1,
                        },
                    });
                    commit('setPlugins', plugins);
                    commit('setFetchPlugins', fetchStatuses.LOADED);
                } catch {
                    commit('setPlugins', []);
                    commit('setFetchPlugins', fetchStatuses.NOT_LOADED_YET);
                }
            }
        },
    },
    namespaced: true,
};
